export const getTipoClausulaNome = (tipo: string) => {
  switch (tipo) {
    case '70afdc88-ed2c-4c5d-8056-3daa2a6ab0b3':
      return 'PARTE I';
    case '0dab57fb-4ed1-4b27-84b7-0a408b872886':
      return 'PARTE II';
  }
};

export const enum ETipoClausulaNome {
  'PARTE1' = '70afdc88-ed2c-4c5d-8056-3daa2a6ab0b3',
  'PARTE2' = '0dab57fb-4ed1-4b27-84b7-0a408b872886',
}
